export function addDataPageAttribute(pageNumber, elements = null) {
    if (!elements) {
        elements = document.querySelectorAll(this.settings.itemCard);
    }
    elements.forEach(element => {
        element.setAttribute('data-page', pageNumber);
    });
}

export function updatePageNumberAndHistory(element) {
    const elementPage = element.getAttribute('data-page');
    const elementId = element.id;
    
    const hash = '#' + elementId || window.location.hash;

    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    searchParams.set('page', elementPage);

    let newUrl = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}${hash}`;
    
    this.currentPage = parseInt(elementPage);
    window.history.replaceState({ path: newUrl }, '', newUrl);
    
}